import {ApolloProvider} from '@apollo/client';
import { toRelativeUrl } from '@okta/okta-auth-js';
import {useOktaAuth} from '@okta/okta-react';
import {LoadingSpinner} from 'common';
import React, {ReactNode, useEffect} from 'react';
import {useAuthenticatedApolloClient} from '../hook/useAuthenticatedApolloClient';
import {CurrentUser} from './CurrentUser';
import {TokenProvider} from './TokenContext';


type AuthenticatedEnvironmentProps = {
    children: ReactNode,
};
export const OktaAuthenticatedEnvironment = ({children}: AuthenticatedEnvironmentProps) => {
    const {oktaAuth, authState} = useOktaAuth();

    // do not use useRouteMatch, it will match the parent Route, not the children Route
    // due to this component's place in the component tree, it will just give the root url, e.g. /provider, /clientplacement...
    const currentUrl = toRelativeUrl(window.location.href, window.location.origin);
    useEffect(() => {
        if (authState && !authState.isAuthenticated) {
            oktaAuth.signInWithRedirect({originalUri: currentUrl});
        }
    }, [ authState , currentUrl, oktaAuth]);
    const apolloClient = useAuthenticatedApolloClient(oktaAuth);

    if (!authState?.isAuthenticated || !apolloClient) {
        return <LoadingSpinner text='Checking your session' centerScreen/>;
    }

    const token = authState.accessToken?.accessToken || null;

    return (
        <ApolloProvider client={apolloClient}>
            <TokenProvider token={token}>
                <CurrentUser>{children}</CurrentUser>
            </TokenProvider>
        </ApolloProvider>
    );
}
